import { CompanyLogo } from "@src/components/modules/Table/VendorsTable/CompanyLogo";
import React, { ReactElement, ReactNode } from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.header`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 0.5rem 2rem;
  border-bottom: 1px solid var(--border-gray-light);
  justify-content: start;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  min-height: var(--header-height);
  background: var(--white);
  animation: slide-down 0.15s ease-out;

  h2 {
    width: 100%;
  }

  .overflow-x-wrap {
    overflow-x: hidden;
  }

  @media print {
    display: none;
  }

  @media screen and (max-width: 40rem) {
    z-index: 1;
    position: fixed;
    width: 100%;
    background: var(--white);
    padding: 0.5rem 1rem 0.5rem 3.5rem;
    h2 {
      font-size: var(--font-size-small);
    }

    h4 {
      font-size: var(--font-size-xsmall);
    }
    &.bar-with-button {
      padding-right: 3.5rem;
    }
  }
`;

type HeaderProps = {
  pageTitle?: string;
  pageTitleFitWidth?: boolean;
  children?: ReactNode;
  companyLogoName?: string;
  label?: string;
  buttons?: ReactElement | ReactElement[];
};

export const Header: React.FC<HeaderProps> = ({
  pageTitle,
  children,
  companyLogoName,
  label,
  buttons,
  pageTitleFitWidth,
}) => (
  <StyledRoot>
    {pageTitle && (
      <div
        className={
          pageTitleFitWidth
            ? ""
            : "full-width overflow-x-wrap column no-gap start"
        }
      >
        <div className="row full-width">
          {companyLogoName && <CompanyLogo size={24} name={companyLogoName} />}
          <h2 className="overflow-width-ellipsis">{pageTitle}</h2>
        </div>
        {label && <h4 className="label font-weight-regular">{label}</h4>}
      </div>
    )}
    {children}
    {buttons}
  </StyledRoot>
);
